import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import * as s from "./styles";

interface ModalCloseButtonProps {
  onClose: () => void;
  disabled?: boolean;
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClose,
  disabled = false,
}) => {
  return (
    <s.StyledIconButton
      aria-label="Fechar"
      onClick={onClose}
      disabled={disabled}
    >
      <CloseIcon />
    </s.StyledIconButton>
  );
};

export default ModalCloseButton;
